<template>
    <div class="rounded shadow bg-grey-bg">
        <header class="flex items-center px-4 bg-white border-b rounded-t h-18 sm:px-6">
            <slot name="header" />
        </header>
        <div
            :class="is_showing_details ? 'block' : 'hidden'"
            class="px-4 py-3 sm:px-6 md:py-4 md:block"
        >
            <slot name="body" />
        </div>
        <button
            :class="is_showing_details ? 'hidden' : 'flex'"
            class="items-center justify-center w-full px-4 py-3 text-sm sm:px-6 md:py-4 md:hidden text-grey-darker"
            @click.prevent="is_showing_details = true"
        >
            Show details
            <base-svg
                name="icon-cheveron-down"
                class="w-4 h-4 fill-current"
            />
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                is_showing_details: this.isOpen
            }
        }
    }
</script>
